import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

export const rutaVentas = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/ventas',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/jornada-caja/PaginaVentas.js'), 'PaginaVentas'),
});
